export default "__VITE_ASSET__2f724072__"